import React, { useEffect } from 'react';
import { AiInsightsModal, BusinessNameAiInsightsModal } from '@wix/domains-search-suite';
import { useInsights } from '../../../hooks/useInsights';
import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
const ConnectedInsightModal = _ref => {
  let isOpen = _ref.isOpen,
    onRequestClose = _ref.onRequestClose,
    domainProp = _ref.domain,
    onGetIt = _ref.onGetIt,
    intent = _ref.intent,
    productType = _ref.productType;
  const _useInsights = useInsights({
      intent,
      productType,
      shouldFetch: Boolean(isOpen)
    }),
    domain = _useInsights.domain,
    description = _useInsights.description,
    bullets = _useInsights.bullets,
    isLoading = _useInsights.isLoading,
    setIndex = _useInsights.setIndex;
  useEffect(() => {
    if (isOpen && domainProp) {
      setIndex(domainProp);
    }
  }, [isOpen, domainProp, setIndex]);
  return /*#__PURE__*/React.createElement(AiInsightsModal, {
    isOpen: Boolean(isOpen),
    onClose: () => {
      onRequestClose == null || onRequestClose();
    },
    onGetIt: () => {
      onRequestClose == null || onRequestClose();
      onGetIt == null || onGetIt(domainProp ?? domain ?? '');
    },
    domain: domainProp ?? domain,
    description: description,
    bullets: bullets,
    isLoading: isLoading
  });
};
export const InsightsModalExtension = ModuleExtensions.modalsExtension({
  aiInsights: ConnectedInsightModal,
  businessNameInsights: BusinessNameAiInsightsModal
}, {
  sdkName: 'insightsModals',
  version: 1
});
//# sourceMappingURL=AiInsightsModalExtension.js.map